<template>
    <v-app id="inspire">
        <v-layout row justify-center>
            <v-dialog v-model="onShow" persistent max-width="40%">
                <v-card>
                    <v-card-title>
                        <span class="subheading">MARS - Pool group administration: {{ poolGroup.name }}</span>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-container grid-list-xs style="overflow-y: auto; margin-top: -20px">
                        <v-layout wrap>
                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Name</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_pool_group_name_field"
                                        v-model="poolGroup.name"
                                        name="name"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                        v-validate="'required:true'"
                                        :error-messages="errors.first('name')"
                                ></v-text-field>
                            </v-flex>


                            <v-flex class="modal-flex-height" xs12 sm5>
                                <v-subheader>Description</v-subheader>
                            </v-flex>

                            <v-flex class="modal-flex-height compact-form" xs12 sm7>
                                <v-text-field
                                        id="modify_pool_group_description_field"
                                        v-model="poolGroup.description"
                                        name="description"
                                        color="grey darken-2"
                                        :disabled="disabled"
                                        class="text-xs-left"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-container>

                    <v-alert :value="error" type="error" transition="scale-transition">
                        {{ errorMessage }}
                    </v-alert>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn id="modify_pool_group_save_button" class="text-none" color="green" small dark @click="onSavePoolGroup" :disabled="disabled">
                            Save
                        </v-btn>
                        <v-btn id="modify_pool_group_cancel_button" class="text-none" small @click="close">Cancel</v-btn>
                    </v-card-actions>

                </v-card>
            </v-dialog>
        </v-layout>
    </v-app>

</template>

<script>

    import poolgroupinterface from "../../../interfaces/poolgroupinterface";
    import {EventBus} from "../../../eventbus";
    import errormessagemanager from "../../../managers/errormessagemanager";

    export default {
        name: 'ShowPoolGroupModal',

        data: () => ({
            headers: [
                {text: '', value: 'poolAssigned', sortable: false},
                {text: 'Name', value: 'name'},
                {text: 'Description', value: 'description'},
                {text: 'Is active', value: 'isActive'},
                {text: 'OUI', value: 'oui'},
                {text: 'Start MAC', value: 'startMac'},
                {text: 'End MAC', value: 'endMac'},
            ],

            error: false,
            errorMessage: null
        }),

        props: {
            value: Boolean,
            editMode: Boolean,
            disabled: Boolean,

            poolGroup: {
                poolGroupId: Number,
                name: String,
                description: String,
                pools: Array
            }
        },

        computed: {
            getTitle: function () {
                return this.editMode ? "Edit" : "Create";
            },

            onShow: {
                get() {
                    return this.value
                },
                set(value) {
                    this.$emit('input', value)
                }
            }
        },

        methods: {
            async onSavePoolGroup() {
                this.clearAlert();
                
                this.$validator.validateAll().then(async result => {
                    if (result) {
                        let response = null;

                        if (!this.editMode) {
                            await poolgroupinterface.postPoolGroup(this.poolGroup, res => {
                                response = res;
                            });
                        } else {
                            await poolgroupinterface.putPoolGroup(this.poolGroup, res => {
                                response = res;
                            });
                        }

                        if (response != null && response.error) {
                            if (!this.editMode) {
                                errormessagemanager.getInsertErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            } else {
                                errormessagemanager.getUpdateErrorMessage(response.status, message => {
                                    this.errorMessage = message;
                                });
                                this.error = response.error;
                            }
                        } else if (!this.error) {
                            await EventBus.$emit('refreshPoolGroupList');
                            await this.close();
                        }
                    }
                });
            },
            
            async close() {
                await EventBus.$emit('poolGroupModalClosed');
                this.onShow = false;

                this.clearData();
                this.clearAlert();
                this.clearValidator();
            },

            clearData() {
                this.poolGroup.poolGroupId = null;
                this.poolGroup.name = null;
                this.poolGroup.description = null;
            },

            clearAlert() {
                this.error = false;
                this.errorMessage = null;
            },
            
            clearValidator() {
                this.$validator.errors.clear();
                this.$validator.fields.items.forEach(field => field.reset());
                this.$validator.fields.items.forEach(field => this.errors.remove(field));
                this.$validator.resume();
            }
        }
    };
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/poolgroups/modals/ShowPoolGroupModal.vue